import React, { useState, useEffect, useRef } from "react";

import { Dialog, Card } from "@mui/material";
import { images, icons, FLAVOR, MAIL_FORMATTING } from "../../helpers/constants";
import { useTranslation } from "react-i18next";
import Button from "../Buttons/Button";
import { useIsMobile } from "../../helpers/customHooks";
import SegmentedControl from "../SegmentedControl/SegmentedControl";
import NewButton from "../Buttons/NewButton";
import DeviceSelectionRow from "../Devices/DeviceSelectionRow";
import toast from "react-hot-toast";
import DeviceSelectionRowNew from "../Devices/DeviceSelectionRowNew";

const SharingModal = ({ show, type, info, onClose, onSave }) => {
	const MOBILE = useIsMobile();
	const { t } = useTranslation();
	const inputFile = useRef(null);

	// const [show, setShow] = useState(props.show)
	const [deviceList, setDeviceList] = useState([]);
	const [allSelected, setAllSelected] = useState(false);
    const [email, setEmail] = useState("")
    const [addedEmails, setAddedEmails] = useState([])
	const [removedEmails, setRemovedEmails] = useState([]); // 👈 new state

	const handleClose = () => {
		onClose();
		setAllSelected(false)
		setEmail("")
		setDeviceList([]);
		setAllSelected(false);
        setAddedEmails([])
	};

	useEffect(() => {
		if(!show){
			handleClose()
		}
	}, [show])

	useEffect(() => {
		if (type === "share_multiple") {
			const prepared = (info || []).map(d => ({ ...d, selected: !!d.selected }));
			setDeviceList(prepared);
			setAllSelected(prepared.length > 0 && prepared.every(dev => dev.selected));
		}
	}, [type, info]);


	useEffect(() => {
		if(type === "alarm_item"){
			setAddedEmails([]); // new emails only
			setRemovedEmails([]);
		}
	}, [type])

	const handleChange = (type, e) => {
		switch (type) {
            case "email":
                setEmail(e.target.value)
			break;
			default:
				return;
		}
	};

	const handleSave = (type) => {
		let data = {};
		switch (type) {
			case "status":
				data = { info };
				break;
			case "share_device":
                if(addedEmails.length === 0){
                    toast.error(t("settings.enter_email"))
                    return
                }
				data = {email: addedEmails}
				break;
			case "alarm_item":
				data = { added: addedEmails, removed: removedEmails, device: [info?.deviceid] }
				break;
			case "share_multiple":
				data = { added: addedEmails, devices: deviceList?.filter(dev => dev.selected).map(dev => dev.deviceid) }
				break;
			case "remove_email":
				data = { email: email }
				break;
			default:
				data = {};
		}
		onSave(data);
	};


    const removeEmail = (emailToRemove) => {
        setAddedEmails(prev => prev.filter(email => email !== emailToRemove));
    };


	const removeEmails = (emailToRemove) => {
        const sharedWith = info?.shared?.sharedwith?.map(e => e.email) || [];

        // Check if the email exists in sharedWith
        if (sharedWith.includes(emailToRemove)) {
            // Add it to removeArray if not already there
            setRemovedEmails(prev =>
                prev.includes(emailToRemove)
                    ? prev
                    : [...prev, emailToRemove]
            );
        }

        // Remove from addedEmails if it's a newly added email
        setAddedEmails(prev => prev.filter(email => email !== emailToRemove));
    };

	const sharedWith = info?.shared?.sharedwith?.map(e => e.email) || [];
	const visibleShared = sharedWith.filter(email => !removedEmails.includes(email));
	const combinedEmails = [...visibleShared, ...addedEmails];



	const toggleDevice = (deviceId) => {
		setDeviceList(prev => {
			const next = prev.map(dev =>
			dev.deviceid === deviceId ? { ...dev, selected: !dev.selected } : dev
			);
			setAllSelected(next.length > 0 && next.every(dev => dev.selected));
			return next;
		});
	};


	const toggleAllDevices = () => {
		setDeviceList(prev => {
			const nextSelected = !allSelected;
			setAllSelected(nextSelected);
			return prev.map(dev => ({ ...dev, selected: nextSelected }));
		});
	};
	const statusContent = () => {
		return (
			<div className="p-3">
				<div className="d-flex flex-row justify-content-between align-items-center">
					<div className="d-flex align-items-center">
						{/* <img src={icons.user_settings} alt=""/> */}
						<h3 className="">{t("settings.sharing_status")}</h3>
					</div>
					<img className="cursor-pointer" src={icons.close_gray} onClick={handleClose} alt="..." />
				</div>
				<div className="d-flex align-items-center pt-3">
					{info?.pending 
					?
					<>
						<div className="bg-red full-rounded p-1 d-flex justify-content-center align-items-center">
							<img src={icons.close} className="white-icon h-100 w-100 size_12" alt=""/>
						</div>
						<p className="grey-blue ms-2">{t("settings.share_device_pending", { user: info?.email })}</p>
					</>
					:
					<>
						<div className="bg-green full-rounded p-2 size24 d-flex justify-content-center align-items-center">
							<img src={icons.check} className="white-icon h-100 w-100" alt=""/>
						</div>
						<p className="grey-blue ms-2">{t("settings.share_device_shared", { user: info?.email })}</p>
					</>
					}

				</div>
				<div className="d-flex flex-row justify-content-between align-items-center mt-4">
					<NewButton onClick={handleClose} className="bg-grey p-3 rounded24 w-100 dark-grey me-2 body bold">
						{t("settings.close")}
					</NewButton>
					<NewButton onClick={() => handleSave(type)} className="bg-red p-3 rounded24 w-100 white-white ms-2 body bold">
						{t("settings.stop_sharing")}
					</NewButton>
				</div>
			</div>
		);
	};

	const shareContent = () => {
		return (
			<div className="p-3">
				<div className="d-flex flex-row justify-content-between align-items-center">
					<div className="d-flex align-items-center">
						{/* <img src={icons.user_settings} alt=""/> */}
						<h3 className="">{t("settings.share_device")}</h3>
					</div>
					<img className="cursor-pointer" src={icons.close_gray} onClick={handleClose} alt="..." />
				</div>
				<p className="grey-blue py-3">{t("settings.share_device_sub")}</p>
                <div className={`d-flex flex-column rounded24 px-2 py-3 bg-light-grey ${addedEmails.length === 0 ? "d-none" : ""} mb-3`}>
                    {addedEmails.map((email, index) => (
                        <div key={index} className={`d-flex justify-content-between align-items-center p-2 rounded12 ${index !== addedEmails.length - 1 ? "mb-2" : ""}`}>
                            <p className="">{email}</p>
                            <NewButton notext={true} className="full-rounded bg-grey p-2" icon={icons.close} iconClass={"dark-grey-icon size_12"} onClick={() => removeEmail(email)}/>
                        </div>
                    ))}
                </div>
                <form>
                    <div className="form-group d-flex align-items-center">
                        <input
                            type="text"
                            className="form-control rounded24 p-3 bg-light-grey grey-blue"
                            id="email"
                            value={email}
                            onChange={(e) => {
                                handleChange("email", e);
                            }}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                if(!MAIL_FORMATTING.test(e.target.value) || addedEmails.includes((e.target.value))){
                                        toast.error(t("settings.error_adding_email"))
                                }else{
                                    const newAddedEmails = [...addedEmails, e.target.value];
                                    setAddedEmails(newAddedEmails); // Update the state with the new array
                                    setEmail("")
                                }
                                e.preventDefault();// Prevent the default Enter key behavior
                                
                                }
                            }}
                        />
                    </div>
                </form>
				<div className="d-flex flex-row justify-content-between align-items-center mt-4">
					<NewButton onClick={handleClose} className="bg-grey p-3 rounded24 w-100 dark-grey me-2 body bold">
						{t("settings.cancel")}
					</NewButton>
					<NewButton onClick={() => handleSave(type)} className="bg-gradient p-3 rounded24 w-100 white-white ms-2 body bold">
						{t("settings.save")}
					</NewButton>
				</div>
			</div>
		);
	};


	const alarmContent = () => {
		return (
            <div className="p-3">
                <div className="d-flex flex-row justify-content-between align-items-center">
                    <div className='d-flex align-items-center'>
                        <h3 className="ms-2">{t("events.sharing_status")}</h3>
                    </div>
                    <img className="cursor-pointer" src={icons.close_gray} onClick={() => onClose()} alt="..." /> 
                </div>
                <p className="grey-blue py-3">{t("events.add_emails_sub", {device: info?.devicename})}</p>
                <div className={`d-flex flex-column rounded24 px-2 py-3 bg-light-grey ${combinedEmails?.length === 0 ? "d-none" : ""} mb-3`}>
                    {combinedEmails?.map((email, index) => (
                        <div key={index} className={`d-flex justify-content-between align-items-center p-2 rounded12 ${index !== combinedEmails?.length - 1 ? "mb-2" : ""}`}>
                            <p>{email}</p>
                            <NewButton notext={true} className="rounded8 bg-grey p-1" icon={icons.close} iconClass={"dark-grey-icon size_12"} onClick={() => removeEmails(email)}/>
                        </div>
                    ))}
                </div>
                <form>
                    <div className="form-group d-flex align-items-center">
                        <input
                            type="text"
                            className="form-control rounded24 p-3 bg-light-grey grey-blue"
                            id="email"
							placeholder={t("settings.email")}
                            value={email}
                            onChange={(e) => {
                                handleChange("email", e);
                            }}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                if(!MAIL_FORMATTING.test(e.target.value) || addedEmails.includes((e.target.value))){
                                        toast.error(t("settings.error_adding_email"))
                                }else{
                                    const newAddedEmails = [...addedEmails, e.target.value];
                                    setAddedEmails(newAddedEmails); // Update the state with the new array
                                    setEmail("")
                                }
                                e.preventDefault();// Prevent the default Enter key behavior
                                
                                }
                            }}
                        />
                    </div>
                </form>

                <div className="d-flex flex-row justify-content-between align-items-center mt-4">
					<NewButton onClick={handleClose} className="bg-grey p-3 rounded24 w-50 me-2 dark-grey ms-auto body bold">
						{t("settings.close")}
					</NewButton>
                    <NewButton 
                        onClick={() => handleSave(type)} 
                        className="bg-gradient p-3 rounded24 w-50 white-white ms-2 body bold">
                        {t("settings.save")}
                    </NewButton>
				</div>
            </div>
		);
	};

	const multipleAlarmContent = () => {
		return (
			<div className="p-3">
				<div className="d-flex flex-row justify-content-between align-items-center">
					<div className="d-flex align-items-center">
						{/* <img src={icons.user_settings} alt=""/> */}
						<h3 className="">{t("settings.share_device")}</h3>
					</div>
					<img className="cursor-pointer" src={icons.close_gray} onClick={handleClose} alt="..." />
				</div>
				<p className="grey-blue py-3">{t("settings.share_device_sub")}</p>
				<div className={`share_device_list scrollable-y rounded24 bg-light-grey mb-3`}>
					<DeviceSelectionRowNew
					text={t("settings.choose_all")}
					selected={allSelected}
					onClick={toggleAllDevices}
					dividerColor="bg-grey"
					/>
					{deviceList.map(device => (
					<DeviceSelectionRowNew
						key={device.deviceid}
						text={device.devicename}
						selected={!!device.selected}
						onClick={() => toggleDevice(device.deviceid)}
						dividerColor="bg-grey"
					/>
					))}
				</div>
				<div className={`d-flex flex-column rounded24 px-2 py-3 bg-light-grey ${addedEmails.length === 0 ? "d-none" : ""} my-3`}>
                    {addedEmails.map((email, index) => (
                        <div key={index} className={`d-flex justify-content-between align-items-center p-2 rounded12 ${index !== addedEmails.length - 1 ? "mb-2" : ""}`}>
                            <p className="">{email}</p>
                            <NewButton notext={true} className="ful-rounded bg-grey p-1" icon={icons.close} iconClass={"dark-grey-icon size_12"} onClick={() => removeEmail(email)}/>
                        </div>
                    ))}
                </div>
                <form>
                    <div className="form-group d-flex align-items-center">
                        <input
                            type="text"
                            className="form-control rounded24 p-3 bg-light-grey grey-blue"
                            id="email"
							placeholder={t("settings.email")}
                            value={email}
                            onChange={(e) => {
                                handleChange("email", e);
                            }}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                if(!MAIL_FORMATTING.test(e.target.value) || addedEmails.includes((e.target.value))){
                                        toast.error(t("settings.error_adding_email"))
                                }else{
                                    const newAddedEmails = [...addedEmails, e.target.value];
                                    setAddedEmails(newAddedEmails); // Update the state with the new array
                                    setEmail("")
                                }
                                e.preventDefault();// Prevent the default Enter key behavior
                                
                                }
                            }}
                        />
                    </div>
                </form>
				<div className="d-flex flex-row justify-content-between align-items-center mt-4">
					<NewButton onClick={handleClose} className="bg-grey p-3 rounded24 w-100 dark-grey me-2 body bold">
						{t("settings.cancel")}
					</NewButton>
					<NewButton onClick={() => handleSave(type)} className="bg-gradient p-3 rounded24 w-100 white-white ms-2 body bold">
						{t("settings.save")}
					</NewButton>
				</div>
			</div>
		);
	};

	const removeEmailContent = () => {
		return (
			<div className="p-3">
				<div className="d-flex flex-row justify-content-between align-items-center">
					<div className="d-flex align-items-center">
						{/* <img src={icons.user_settings} alt=""/> */}
						<h3 className="">{t("settings.remove_email")}</h3>
					</div>
					<img className="cursor-pointer" src={icons.close_gray} onClick={handleClose} alt="..." />
				</div>
				<p className="grey-blue py-3">{t("settings.remove_email_sub")}</p>

                <form>
                    <div className="form-group d-flex align-items-center">
                        <input
                            type="text"
                            className="form-control rounded24 p-3 bg-light-grey grey-blue"
                            id="email"
                            value={email}
                            onChange={(e) => {
                                handleChange("email", e);
                            }}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                if(!MAIL_FORMATTING.test(e.target.value) || addedEmails.includes((e.target.value))){
                                        toast.error(t("settings.error_adding_email"))
                                }else{
									handleSave(type)
                                    //const newAddedEmails = [...addedEmails, e.target.value];
                                    //setAddedEmails(newAddedEmails); // Update the state with the new array
                                    //setEmail("")
                                }
                                e.preventDefault();// Prevent the default Enter key behavior
                                
                                }
                            }}
                        />
                    </div>
                </form>
				<div className="d-flex flex-row justify-content-between align-items-center mt-4">
					<NewButton onClick={handleClose} className="bg-grey p-3 rounded24 w-100 dark-grey me-2 body bold">
						{t("settings.cancel")}
					</NewButton>
					<NewButton onClick={() => handleSave(type)} className="bg-red p-3 rounded24 w-100 white-white ms-2 body bold">
						{t("settings.remove")}
					</NewButton>
				</div>
			</div>
		);
	};



	const typeRender = () => {
		switch (type) {
			case "status":
				return statusContent();
			case "share_device":
				return shareContent();
			case "alarm_item":
				return alarmContent();
			case "share_multiple":
				return multipleAlarmContent();
			case "remove_email":
				return removeEmailContent();
			default:
				return null;
		} 
	};

	return (
		<>
			<Dialog fullWidth={MOBILE ? true : false} open={show} onClose={handleClose}>
				<Card className="settings-dialog d-flex flex-column">
					<div className="w-100 h-100 grey-blue">{typeRender()}</div>
				</Card>
			</Dialog>
		</>
	);
};

export default SharingModal;
